const UserStatus = {
	PENDING_VERIFICATION: 2,
	ACTIVE: 1,
	SUSPENDED: 0,
	DELETED: -1,
};

export default UserStatus;
